import React from "react";

import { Button } from "./Button";
import { CommonProps } from "./buttonCommon";
import { GatsbyLink } from "./GatsbyLink";
import { HrefLink } from "./HrefLink";
import { LinkSpec } from "./linkSpec";
import { LocaleLink } from "./api/LocaleLink";

interface UniversalLinkProps extends CommonProps {
  spec: LinkSpec;
  children?: React.ReactNode;
}

export const UniversalLink = (props: UniversalLinkProps) => {
  const { spec, children, ...rest } = props;
  if (spec.kind === "link") {
    return (
      <GatsbyLink stopPropagation={spec.stopPropagation} to={spec.to} {...rest}>
        {children}
      </GatsbyLink>
    );
  } else if (spec.kind === "external-link") {
    return (
      <HrefLink href={spec.href} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </HrefLink>
    );
  } else if (spec.kind === "button") {
    return (
      <Button type="button" onClick={spec.onClick} {...rest}>
        {children}
      </Button>
    );
  } else {
    return (
      <Button type="button" {...rest}>
        {children}
      </Button>
    );
  }
};

interface UniversalLinkWrapperProps {
  spec: LinkSpec;
  className?: string;
  children?: React.ReactNode;
}

export const UniversalLinkWrapper = React.forwardRef<HTMLElement, UniversalLinkWrapperProps>((props, ref) => {
  const { spec, children, ...rest } = props;
  if (spec.kind === "link") {
    return (
      <LocaleLink stopPropagation={spec.stopPropagation} ref={ref} to={spec.to} {...rest}>
        {children}
      </LocaleLink>
    );
  } else if (spec.kind === "external-link") {
    return (
      <a ref={ref as any} href={spec.href} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  } else if (spec.kind === "button") {
    return (
      <a ref={ref as any} onClick={spec.onClick} {...rest}>
        {children}
      </a>
    );
  } else {
    return (
      <div ref={ref as any} {...rest}>
        {children}
      </div>
    );
  }
});
